import React from 'react';
import { ArrowRightIcon, MonitorIcon } from 'lucide-react';
import { Bullet, PAD, Panel, Reveal, SlideFrame, SlideHeader, t } from './primitives';
import { StoryboardButton } from './Storyboard';
const MARKETS = ['UK', 'DK', 'DE', 'ES', 'IT', 'NL', 'AU', 'CA', 'JP', '+60 more'];
export function OperatingModel() {
  return <SlideFrame data-id="element-175" data-mp="y44nq9k608rg">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-176" data-mp="y3lhhq3vn8t9">
        <SlideHeader eyebrow="11 — Operating model" title="The LEO" accent="operating model" kicker="Snakker for LEO Pharma" data-id="element-177" data-mp="1bvi45ems0qi9" />

        <div className="mt-[3vh] flex min-h-0 flex-1 flex-col" data-id="element-178" data-mp="1lu7aca5b8mio">
          <Reveal delay={0.2} className="shrink-0" data-id="element-179" data-mp="1lsefrt7z1sr1">
            <div className="flex items-center gap-[1.4vw] rounded-[0.6vw] border border-[#7D38E5]/60 bg-[#7D38E5]/[0.14] px-[1.6vw] py-[1.6vh]" data-id="element-180" data-mp="1gv4jbtm60gtp">
              <MonitorIcon aria-hidden className="h-[clamp(12px,1.5vw,30px)] w-[clamp(12px,1.5vw,30px)] shrink-0 text-[#A26BFF]" data-id="element-181" data-mp="3nny7z1ehjuj4" />
              <span className={`${t.label} shrink-0 font-semibold uppercase tracking-[0.2em] text-[#A26BFF]`} data-id="element-182" data-mp="2pmmnypfpykje">
                Control Tower
              </span>
              <p className={`${t.label} leading-[1.4] text-white/80`} data-id="element-183" data-mp="2yl80a2ull3bq">
                Visibility, transparency, and control for Ryan, Jacob, and central
                stakeholders across the ecosystem.
              </p>
            </div>
          </Reveal>

          <div aria-hidden className="relative h-[3.4vh] shrink-0" data-id="element-184" data-mp="3dannx9yu0sn7">
            <span className="absolute left-[25%] top-0 h-full border-l border-dashed border-white/25" data-id="element-185" data-mp="3dd0geh27ulei" />
            <span className="absolute left-[75%] top-0 h-full border-l border-dashed border-white/25" data-id="element-186" data-mp="3haepm8pwct6i" />
          </div>

          <div className="grid min-h-0 flex-1 grid-cols-[1fr_auto_1fr] items-stretch gap-[1.2vw]" data-id="element-187" data-mp="1myhtw3kf915n">
            <Reveal delay={0.32} className="flex min-h-0" data-id="element-188" data-mp="1rxb5fqg5ei36">
              <Panel index="01" label="Global brand" className="w-full" data-id="element-189" data-mp="1rxtb1dopa8nr">
                <Bullet data-id="element-190" data-mp="2v9i6lrinuluh">Creates the strategic campaign master</Bullet>
                <Bullet data-id="element-191" data-mp="2q9ngvramg2b0">Defines the core messages and campaign intent</Bullet>
                <div className="mt-auto flex items-center gap-[0.6vw] border-t border-white/10 pt-[1.4vh]" data-id="element-192" data-mp="2qbqhf59ehdtz">
                  <span className={`${t.label} rounded-full border border-white/15 px-[0.8vw] py-[0.5vh] text-white/60`} data-id="element-193" data-mp="2za24ixb25tho">
                    1 master
                  </span>
                  <span className={`${t.label} rounded-full border border-white/15 px-[0.8vw] py-[0.5vh] text-white/60`} data-id="element-194" data-mp="398rmsr6v9fyg">
                    Reusable assets
                  </span>
                </div>
              </Panel>
            </Reveal>

            <Reveal delay={0.4} className="flex items-center justify-center" data-id="element-195" data-mp="sg4l073sy23">
              <ArrowRightIcon aria-hidden className="h-[clamp(14px,2vw,40px)] w-[clamp(14px,2vw,40px)] text-[#A26BFF]" data-id="element-196" data-mp="qbws7633ewj" />
            </Reveal>

            <Reveal delay={0.48} className="flex min-h-0" data-id="element-197" data-mp="ffwt1u0g6aps">
              <Panel index="02" label="Local affiliate" className="w-full" data-id="element-198" data-mp="kehu1vniwyfa">
                <Bullet data-id="element-199" data-mp="5h7m2wa3aaob">Activates what is relevant in-market</Bullet>
                <Bullet data-id="element-200" data-mp="5j1xnjzh0qfq">
                  A lower-cost, faster route to high-quality campaign execution
                </Bullet>
                <div className="mt-auto flex flex-wrap gap-[0.4vw] border-t border-white/10 pt-[1.4vh]" data-id="element-201" data-mp="3subcwh5bulzi">
                  {MARKETS.map(market => <span key={market} className={`${t.label} rounded-full border border-white/15 px-[0.7vw] py-[0.45vh] text-white/60`} data-id="element-202" data-mp="1gotv14ab2ll">
                      {market}
                    </span>)}
                </div>
              </Panel>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.6} className="mt-[2.8vh] flex shrink-0 items-end justify-between gap-[2vw] border-t border-white/10 pt-[2.4vh]" data-id="element-203" data-mp="3dvpr0p4qha3p">
          <p className={`${t.small} max-w-[72%] font-medium leading-[1.35] text-white`} data-id="element-204" data-mp="31urgb590p5qm">
            Snakker is the delivery engine. Control Tower is the visibility and
            governance layer.{' '}
            <span className="text-[#A26BFF]" data-id="element-205" data-mp="2s4y7gc09f4q2">
              Together, a scalable global-to-local operating model for LEO Pharma.
            </span>
          </p>
          <StoryboardButton label="Storyboard · PDF" data-id="element-206" data-mp="2o104fq7td9rq" />
        </Reveal>
      </div>
    </SlideFrame>;
}